import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface UserPreferences {
  id: string;
  user_id: string;
  academic_goal: string | null;
  intended_course: string | null;
  selected_exam_ids: string[];
  recommended_subject_ids: string[];
  onboarding_completed: boolean;
  is_premium: boolean;
}

export function usePreferences() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["user_preferences", user?.id],
    enabled: !!user?.id,
    queryFn: async (): Promise<UserPreferences | null> => {
      const { data, error } = await supabase
        .from("user_preferences")
        .select("*")
        .eq("user_id", user!.id)
        .maybeSingle();
      if (error) throw error;
      return data as UserPreferences | null;
    },
  });
}
